import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PageTitleAsBreadCrumbs from '../../../shared/PageTitleAsBreadCrumbs';
import { productSaveService } from '../../../services/productSaveService';
import ItemName from '../../../shared/ItemName';
import { productNamesService } from '../../../services/productNamesService';
import UpdateSeveralPropertiesPopup from './UpdateSeveralPropertiesPopup';
import FormsHandler from '../../formStructure/FormsHandler';
import { formsProductService } from '../../../services/formsProductService';
import { formsStorage } from '../../../services/formsStorage';
import LastUpdateTime from '../../../shared/LastUpdateTime';
import NonEditableItemCode from '../../../shared/NonEditableItemCode';
import { propertiesStorage } from '../../../services/propertiesStorage';
import ProductPropertiesListHandler from './ProductPropertiesListHandler';
import { SMALL_WEB_SCREEN_WIDTH } from '../../../constant';
import DeleteProductPropertyPopup from './DeleteProductPropertyPopup';
import ItemProductCategory from '../../../shared/ItemProductCategory';
import ProductSvgAssetsBlock from './ProductSvgAssetsBlock';
import ProductCharacteristics from './ProductCharacteristics';
import ProductCompositionFields from './ProductCompositionFields';

const productNameSaveService = {
    updateItemLocalization(locale, value) {
        productSaveService.updateProductName(locale, value);
    },
};

const EditProductTab = () => {
    const [activeItem, setActiveItem] = useState({});
    const { id } = useParams();

    const updateActiveItem = () => {
        if (id && (!Object.prototype.hasOwnProperty.call(activeItem,"id") || activeItem.id !== id)) {
            setActiveItem({...productSaveService.getProduct()});
        }
    };

    useEffect(() => {
        if(id) {
            productSaveService.loadProduct(id, updateActiveItem);
            productSaveService.registerItemUpdateObserver(updateActiveItem);
            formsStorage.loadItems(() => null, SMALL_WEB_SCREEN_WIDTH + 1, '?valid=true');
            propertiesStorage.loadItems(() => null, SMALL_WEB_SCREEN_WIDTH + 1, '?valid=true');
        }
        return () => {
            productSaveService.unRegisterItemUpdateObserver(updateActiveItem);
            formsStorage.cleanStorage();
            propertiesStorage.cleanStorage();
        };
    }, [id]);

    return (
        activeItem.id &&
            <>
                <PageTitleAsBreadCrumbs />
                <article className="product__article product__article-add">
                    <LastUpdateTime itemSaveService={productSaveService}/>
                    <form className="product__form">
                        <ItemName
                            itemCode={productSaveService.getProduct()}
                            itemService={productNamesService}
                            itemSaveService={productNameSaveService}
                        />
                        <NonEditableItemCode itemCode={activeItem.productCode} />
                        <ItemProductCategory itemsStorageService={productSaveService} />
                        <FormsHandler selectWithTokensManager={formsProductService} />
                        <ProductCharacteristics productId={activeItem.id}/>
                        <ProductCompositionFields productId={activeItem.id}/>
                    </form>
                    <ProductSvgAssetsBlock key={id} productId={id} />
                    <ProductPropertiesListHandler properties={productSaveService.getSortedProperties()} />
                </article>
                <UpdateSeveralPropertiesPopup />
                <DeleteProductPropertyPopup />
            </> 
    );
};

export default EditProductTab;
